import { Input, Label, useId } from "@fluentui/react-components";
import ITextFieldProps from "./ITextFieldProps";
import useStyles from "../TextFieldStyles";
  
export default function TextField(props: ITextFieldProps) {
    const inputId = useId("input");
    const styles = useStyles();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        props.onChange(e.target.value);
    };

    return (
        <div className={styles.root}>
            <Label htmlFor={inputId} size="medium" disabled={props.disabled}>
                {props.label}
            </Label>
            <Input
                id={inputId}
                type={props.type}
                value={props.value}
                disabled={props.disabled}
                required={props.required}
                onChange={handleChange}
                placeholder={props.placeholder}
                autoComplete="off"
                />
        </div>
    );
}